/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Vocabulary } from "../../Utils/Vocabulary";
import {
  Button,
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import {  toast } from "react-toastify";import { Delete, Edit } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { LocalUrlEnum, UrlEnum } from "../../Utils/Utils";
import theme from "../../Theme/Theme";
import style from "./Devices.module.scss";
import { getData } from "../../Services/getData";
import { deleteData } from "../../Services/deleteData";
import DeleteDeviceModal from "./DeleteDeviceModal";
import ImportExcelModal from "./ImportExcelModal";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import { BreadCrumbsContext } from "../../Context/breadCrumbsContext";
import { breadCrumbsEnum } from "../../Utils/Constants";

export default function Devices() {
  const navigate = useNavigate();
  const location = useLocation();
  const breadCrumbsContext = useContext(BreadCrumbsContext);
  const notifyError = (message: string) => toast.error(message);
  const notifySuccess = (message: string) => toast.success(message);
  const [deleteId, setDeleteId] = useState(null);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState<any>({
    devices: [],
    devicesNumber: 0,
    page: 0,
    perPage: 10,
    search: null,
    order: "asc",
    filter: null,
    preview: false,
    selectedRequest: {},
    loading: false,
  });
  const userName = localStorage.getItem("userName")
    ? localStorage.getItem("userName")
    : "";

  useEffect(() => {
    breadCrumbsContext.setBreadCrumbs([`${breadCrumbsEnum.devices}`]);
    const search = location.search.split("?");
    const newState = Object.assign({}, state);
    search.forEach((value) => {
      if (value !== "") {
        const values = value.split("=");
        if (values[0] === "page") newState[values[0]] = +values[1] - 1;
        else newState[values[0]] = isNaN(+values[1]) ? values[1] : +values[1];
      }
    });
    getDevices(newState.page, newState.perPage, newState.search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  /**
   *
   */
  async function getDevices(
    page: number,
    perPage: number,
    search?: string | null
  ) {
    setLoading(true);
    let url = `${UrlEnum.devices}/${page}/${perPage}`;
    if (search) {
      url = `${UrlEnum.devices}/${page}/${perPage}/${search}`;
    }
    await getData(url)
      .then((res) => {
        setState({
          ...state,
          devices: res.data.devices,
          devicesNumber: res.data.devicesNumber,
          page: page,
          perPage: perPage,
          search: search || null,
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notifyError(Vocabulary.getError);
      });
  }

  /**
   *
   */
  const devicesHeaders = [
    {
      label: `${Vocabulary.deviceName.toUpperCase()}`,
      name: "deviceName",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      label: `${Vocabulary.manufacturer.toUpperCase()}`,
      name: "manufacturer",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.model.toUpperCase()}`,
      name: "model",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.deviceType.toUpperCase()}`,
      name: "deviceType",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return <>{Vocabulary[value] || ""}</>;
        },
      },
    },
    {
      label: `${Vocabulary.category.toUpperCase()}`,
      name: "category",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return <>{value ? value.name : ""}</>;
        },
      },
    },
    {
      label: `${Vocabulary.options.toUpperCase()}`,
      name: "Optiuni",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRenderLite: (rowIndex: number) => {
          return (
            <div style={{ marginTop: -10, marginBottom: -10 }}>
              <ToggleButtonGroup exclusive aria-label="text alignment">
                <Tooltip title={Vocabulary.edit}>
                  <ToggleButton
                    onClick={() => {
                      navigate(
                        `${LocalUrlEnum.devices}${state.devices[rowIndex]._id}`
                      );
                    }}
                    value="center"
                    aria-label="centered"
                  >
                    <Edit />
                  </ToggleButton>
                </Tooltip>
                <Tooltip title={Vocabulary.delete}>
                  <ToggleButton
                    onClick={(event) => {
                      event.stopPropagation();
                      setOpenDeleteModal(true);
                      setDeleteId(state.devices[rowIndex]._id);
                    }}
                    value="center"
                    aria-label="centered"
                  >
                    <Delete />
                  </ToggleButton>
                </Tooltip>
              </ToggleButtonGroup>
            </div>
          );
        },
      },
    },
  ];

  /**
   *
   * @returns
   */
  function getTableOptions() {
    const responsive: "standard" | "vertical" | "simple" | undefined =
      "standard";
    return {
      selectableRows: "none" as any,
      viewColumns: false as any,
      responsive: responsive,
      rowsPerPageOptions: [10, 20, 50, 100],
      confirmFilters: true,
      filter: false,
      print: false,
      download: false,
      textLabels: {
        body: {
          noMatch: Vocabulary.noResultsFound,
        },
      },
      count: state.devicesNumber,
      rowsPerPage: state.perPage,
      page: state.page,
      search: true,
      serverSide: true,
      sort: true,
      setRowProps: () => {
        return {
          style: {
            cursor: "pointer",
          },
        };
      },
      onRowClick: (rowData: any, rowState: any) => {
        navigate(
          `${LocalUrlEnum.devices}${state.devices[rowState.rowIndex]._id}`
        );
      },
      onChangePage: (page: any) => {
        setState({ ...state, page: page });
        if (state.search)
          navigate(
            `${LocalUrlEnum.devices}?page=${page + 1}?perPage=${
              state.perPage
            }?search=${state.search}`
          );
        else
          navigate(
            `${LocalUrlEnum.devices}?page=${page + 1}?perPage=${state.perPage}`
          );
        window.scrollTo(0, 0);
      },
      onChangeRowsPerPage: (numberOfRows: number) => {
        setState({ ...state, perPage: numberOfRows });
        if (state.search)
          navigate(
            `${LocalUrlEnum.devices}?page=${1}?perPage=${numberOfRows}?search=${
              state.search
            }`
          );
        else
          navigate(`${LocalUrlEnum.devices}?page=${1}?perPage=${numberOfRows}`);
        window.scrollTo(0, 0);
      },
      onSearchChange: async (search: string | null) => {
        if (search) {
          setState({ ...state, search: search });
          navigate(
            `${LocalUrlEnum.devices}?page=${state.page + 1}?perPage=${
              state.perPage
            }?search=${search}`
          );
        } else {
          navigate(
            `${LocalUrlEnum.devices}?page=${state.page + 1}?perPage=${
              state.perPage
            }`
          );
          setState({ ...state, search: null });
        }
      },
      onSearchClose: async () => {
        navigate(
          `${LocalUrlEnum.devices}?page=${state.page + 1}?perPage=${
            state.perPage
          }`
        );
        setState({ ...state, search: null });
      },
    };
  }

  /**
   *
   */
  function addNewDevice() {
    navigate(`${LocalUrlEnum.devices}0`);
  }

  /**
   *
   *
   */
  function handleDelete() {
    setLoading(true);
    deleteData(`${UrlEnum.devices}/${deleteId}/${userName}`)
      .then(async (res) => {
        await getDevices(state.page, state.perPage);
        setLoading(false);
        setOpenDeleteModal(false);
        notifySuccess(Vocabulary.deleteSuccess);
      })
      .catch((err) => {
        setLoading(false);
        setOpenDeleteModal(false);
        notifyError(Vocabulary.deleteError);
      });
  }

  return (
    <>
       <div className={style.devicesBtn}>
        <Button
          variant="contained"
          size="large"
          style={{
            color: theme.palette.whiteColor?.main,
            backgroundColor: theme.palette.dashboard?.main,
          }}
          onClick={addNewDevice}
        >
          <AddCircleIcon />
          &nbsp;&nbsp;{Vocabulary.newDevice}
        </Button>
        <Button
          variant="contained"
          size="large"
          style={{
            color: theme.palette.whiteColor?.main,
            backgroundColor: theme.palette.dashboard?.main,
          }}
          onClick={() => setOpenImportModal(true)}
        >
          <DriveFileMoveIcon />
          &nbsp;&nbsp; {Vocabulary.excelImport}
        </Button>
      </div>
      <MUIDataTable
        title={Vocabulary.devices}
        data={state.devices}
        columns={devicesHeaders}
        options={getTableOptions()}
      />
      {openDeleteModal ? (
        <DeleteDeviceModal
          openDeleteModal={openDeleteModal}
          setOpenDeleteModal={setOpenDeleteModal}
          handleDelete={handleDelete}
        />
      ) : (
        ""
      )}
      {openImportModal ? (
        <ImportExcelModal
          setLoading={setLoading}
          openImportModal={openImportModal}
          setOpenImportModal={setOpenImportModal}
        />
      ) : (
        ""
      )}
      {loading ? (
        <div className="loading">
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
    </>
  );
}
